import { getSafeReturnUrl } from "merchant-core";

const AUTH_ENTRY_PATHS = new Set(["/login"]);

const getPathname = (relativePath: string): string => {
  return new URL(relativePath, "https://relative-url.invalid").pathname;
};

export const getAuth0RedirectPath = (returnTo?: string): string => {
  const redirectPath = getSafeReturnUrl(returnTo, "/") || "/";
  const redirectPathname = getPathname(redirectPath);

  return AUTH_ENTRY_PATHS.has(redirectPathname) ? "/" : redirectPath;
};

export const getAuth0ReturnTo = (): string => {
  if (globalThis.window === undefined) {
    return "/";
  }

  const { location } = globalThis.window;

  return getAuth0RedirectPath(location.pathname + location.search);
};
